import { render } from "./Hero.vue?vue&type=template&id=1c9d23c6&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=1c9d23c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9d23c6"],['__file',"src/js/components/Hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c9d23c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c9d23c6', __exports__)) {
    api.reload('1c9d23c6', __exports__)
  }
  
  module.hot.accept("./Hero.vue?vue&type=template&id=1c9d23c6&scoped=true", () => {
    api.rerender('1c9d23c6', render)
  })

}


export default __exports__